import { render, staticRenderFns } from "./authorDetails.vue?vue&type=template&id=168a17ea&scoped=true&"
import script from "./authorDetails.vue?vue&type=script&lang=js&"
export * from "./authorDetails.vue?vue&type=script&lang=js&"
import style0 from "./authorDetails.vue?vue&type=style&index=0&id=168a17ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168a17ea",
  null
  
)

export default component.exports